export default {
  getConfig() {
    return {
      localUrl: 'https://cgad.dev.nowdigital.fr',
    };
  },
}



// WEBPACK FOOTER //
// ./scripts/api-config.js